import { mainServer } from "../../variables/config"

export const request_orders = async(params) => {
    const credentials = JSON.parse(localStorage.getItem('token_data'))
    mainServer.defaults.headers.common['Authorization'] = credentials.token
    const response = await mainServer.get(`/order/me`, {params:{...params}})
    return response.data.data
}
